import { genderList } from "../shared/grailConstants";
import { StringFormCombobox } from "@/components/forms/FormCombobox";

interface GenderSelectProps {
  isErrored?: boolean;
  onChange: (...event: unknown[]) => void;
  readOnly?: boolean;
  required?: boolean;
  value?: string | null;
}

export default function GenderSelect(props: GenderSelectProps) {
  const { isErrored, onChange, readOnly, value, required } = props;

  return (
    <StringFormCombobox
      id="gender-select"
      options={genderList}
      value={value}
      onChange={(next) => onChange(next)}
      readOnly={readOnly}
      required={required}
      isErrored={isErrored}
      autoComplete="new-password"
      creatable={{
        // Create only via this row (or Enter while highlighted). Blur reverts —
        // see StringFormCombobox close policy (clearOnBlur).
        formatLabel: (query) => `Self-Describe: ${query}`,
      }}
    />
  );
}
